export default __webpack_public_path__ + "static/media/SortDownArrow.864fff2b.svg";